import { IconProps as MuiIconProps } from '@mui/material'
import { Icon as MuiIcon } from '@mui/material'

import { IconName } from './components/custom-icons'
import customIcons from './components/custom-icons'

interface IconProps extends MuiIconProps {
    name: IconName
}

export const Icon = ({ name, ...props }: IconProps): JSX.Element => {
    return <MuiIcon component={(innerProps) => customIcons[name as IconName].render({ ...innerProps })} {...props} />
}

export default Icon
